export default __webpack_public_path__ + "static/banner_1_0-d4af06dffd478b210e97a384326fc404.jpg";